const persistedDivision = window.localStorage.getItem('previousDivision');

const initialDivision = persistedDivision
  ? JSON.parse(persistedDivision)
  : { value: '', label: '' };

const initialState = {
  error: false,
  errorInfo: {},
  foldersJson: [],
  divisionOptions: [],
  folderOptions: [],
  fetchedFolders: {},
  unitType: 'Tickets',
  division: initialDivision,
  folder: { value: '', label: '' },
  selectedCity: {},
  fromDueDate: '',
  toDueDate: '',
  allDocs: [],
  sortedDocs: [],
  sortCriterion: '',
  filteredTicketIds: [],
  filtersArray: [],
  selectedTickets: [],
  allTicketsSelected: false,
  matchingTickets: {},
  modalResponseType: null,
  selectedMatch: null,
  ticketDetail: null,
  ticketDetailLogs: {},
  mapView: false,
  viewComponent: [],
  mapExtent: null,
  mapZoom: null,
  closedTicketsVisible: true,
  isNotesAndPhotosModalVisible: false,
  isMoveModalVisible: false,
  isRespondModalVisible: false,
  isReopenModalVisible: false,
  isBreakInModalVisible: false,
  isFolderDrawerVisible: false,
  ticketGroupLabel: '',
  filteredClosedTodayArray: [],
  selectedCellOpenTickets: [],
  selectedCellClosedTickets: [],
  areOpenClosedButtonsVisible: false,
  selectedCell: null,
  searchInput: '',
  searchValue: '',
  searchResults: [],
  selectedTicketResponseType: '',
  selectedTicketStatus: 'OPEN',
  selectedPriority: '',
  selectedDigIn: '',
  foldersLoaded: 0,
  docPins: [],
  access: {},
  permissions: [],
  roles: [],
  toggledDocTypes: {
    ticket: true,
    fieldMeet: true,
    standby: true,
  },
  isUploadingPhotos: false
};

export { initialState };

export default function reducer(state, action) {
  switch (action.type) {
    case 'CLEAR_ERROR':
      return { ...state, error: false, errorInfo: {} };
    case 'LOAD_FOLDERS_JSON_SUCCESS':
      return { ...state, foldersJson: action.payload };
    case 'LOAD_DOCS_SUCCESS':
      return { ...state, allDocs: action.payload };
    case 'LOAD_TICKET_DETAIL':
      return { ...state, ticketDetail: action.payload };
    case 'LOAD_TICKET_LOGS':
      return { ...state, ticketDetailLogs: action.payload };
    case 'UPDATE_DIVISION_SUPERVISOR':
      return { ...state, foldersJson: action.payload };
    case 'LOAD_MATCHING_TICKETS':
      return { ...state, matchingTickets: action.payload };
    case 'UPDATE_DIVISION_OPTIONS':
      return { ...state, divisionOptions: action.payload };
    case 'UPDATE_FOLDER_OPTIONS':
      return { ...state, folderOptions: action.payload };
    case 'UPDATE_FETCHED_FOLDERS':
      return { ...state, fetchedFolders: action.payload };
    case 'UPDATE_SELECTED_TICKETS':
      return { ...state, selectedTickets: action.payload };
    case 'UPDATE_FILTERED_TICKET_IDS':
      return { ...state, filteredTicketIds: action.payload };
    case 'UPDATE_FILTERS_ARRAY':
      return { ...state, filtersArray: action.payload };
    case 'UPDATE_DIVISION':
      return {
        ...state,
        division: action.payload,
        folder: { value: '', label: '' },
      };
    case 'UPDATE_FOLDER':
      return { ...state, folder: action.payload };
    case 'UPDATE_MAP_VIEW':
      return { ...state, viewComponent: action.payload };
    case 'UPDATE_MAP_EXTENT':
      return { ...state, mapExtent: action.payload };
    case 'UPDATE_MAP_ZOOM':
      return { ...state, mapZoom: action.payload };
    case 'UPDATE_MODAL_RESPONSE_TYPE':
      return { ...state, modalResponseType: action.payload };
    case 'UPDATE_SELECTED_MATCH':
      return { ...state, selectedMatch: action.payload };
    case 'UPDATE_UNIT_TYPE':
      return { ...state, unitType: action.payload };
    case 'UPDATE_SORTED_DOCS':
      return { ...state, sortedDocs: action.payload };
    case 'UPDATE_SORT_CRITERION':
      return { ...state, sortCriterion: action.payload };
    case 'UPDATE_TICKET_GROUP_LABEL':
      return { ...state, ticketGroupLabel: action.payload };
    case 'UPDATE_FILTERED_CLOSED_TODAY_ARRAY':
      return { ...state, filteredClosedTodayArray: action.payload };
    case 'UPDATE_SELECTED_CELL_OPEN_TICKETS':
      return { ...state, selectedCellOpenTickets: action.payload };
    case 'UPDATE_SELECTED_CELL_CLOSED_TICKETS':
      return { ...state, selectedCellClosedTickets: action.payload };
    case 'UPDATE_SEARCH_INPUT':
      return { ...state, searchInput: action.payload };
    case 'UPDATE_SEARCH_VALUE':
      return { ...state, searchValue: action.payload };
    case 'UPDATE_SEARCH_RESULTS':
      return { ...state, searchResults: action.payload };
    case 'UPDATE_SELECTED_CITY':
      return { ...state, selectedCity: action.payload };
    case 'UPDATE_FROM_DUEDATE':
      return { ...state, fromDueDate: action.payload };
    case 'UPDATE_TO_DUEDATE':
      return { ...state, toDueDate: action.payload };
    case 'UPDATE_SELECTED_TICKET_STATUS':
      return { ...state, selectedTicketStatus: action.payload };
    case 'UPDATE_SELECTED_LAN_ID':
      return { ...state, selectedLanID: action.payload };
    case 'UPDATE_SELECTED_PRIORITY':
      return { ...state, selectedPriority: action.payload };
    case 'UPDATE_SELECTED_DIGIN':
      return { ...state, selectedDigIn: action.payload };
    case 'UPDATE_FOLDERS_LOADED':
      return { ...state, foldersLoaded: action.payload };
    case 'UPDATE_DOCPINS':
      return { ...state, docPins: action.payload };
    case 'TOGGLE_OPEN_CLOSED_BUTTONS':
      return { ...state, areOpenClosedButtonsVisible: action.payload };
    case 'TOGGLE_CLOSED_TICKETS':
      return {
        ...state,
        closedTicketsVisible: action.payload,
        selectedTickets: [],
      };
    case 'UPDATE_SELECTED_CELL':
      return { ...state, selectedCell: action.payload };
    case 'UPDATE_SELECTED_TICKET_RESPONSE_TYPE':
      return { ...state, selectedTicketResponseType: action.payload };
    case 'TOGGLE_MAP_VIEW':
      return { ...state, mapView: action.payload };
    case 'TOGGLE_NOTES_AND_PHOTOS_MODAL':
      return { ...state, isNotesAndPhotosModalVisible: action.payload };
    case 'TOGGLE_MOVE_MODAL':
      return { ...state, isMoveModalVisible: action.payload };
    case 'TOGGLE_RESPOND_MODAL':
      return { ...state, isRespondModalVisible: action.payload };
    case 'TOGGLE_REOPEN_MODAL':
      return { ...state, isReopenModalVisible: action.payload };
    case 'TOGGLE_BREAKIN_MODAL':
      return { ...state, isBreakInModalVisible: action.payload };
    case 'TOGGLE_FOLDER_DRAWER':
      return { ...state, isFolderDrawerVisible: action.payload };
    case 'TOGGLE_ALL_TICKETS_SELECTED':
      return { ...state, allTicketsSelected: action.payload };
    case 'UPDATE_ACCESS': {
      return {
        ...state,
        access: action.payload,
      };
    }
    case 'UPDATE_PERMISSIONS': {
      return {
        ...state,
        permissions: action.payload,
      };
    }
    case 'UPDATE_ROLES': {
      return {
        ...state,
        roles: action.payload,
      };
    }
    case 'UPDATE_TOGGLED_DOCTYPES': {
      return {
        ...state,
        toggledDocTypes: action.payload,
      };
    }
    case 'TOGGLE_UPLOADING_PHOTOS': {
      return {
        ...state,
        isUploadingPhotos: action.payload,
      };
    }
    default:
      return state;
  }
}
